import { USER } from "./action";

const INITIAL_STATE = {
  isPlanCancelled: false,
  isLoading: false
};

export function subscriptionList(state = INITIAL_STATE, action) {
  switch (action.type) {
    case USER.subscriptionList.success:
      return Object.assign({}, state, {
        subscriptionListDetails: action.data,
        subStarted: false
      });
    case USER.subscriptionPlan.started: //here
      return Object.assign({}, state, {
        subscriptionPlanDetail: {},
        subStarted: true
      });
    case USER.subscriptionPlan.success: //here
      return Object.assign({}, state, {
        subscriptionPlanDetail: action.data,
        subStarted: false
      });
    case USER.subscriptionPlan.error: //here
      return Object.assign({}, state, {
        subError: action.data,
        subscriptionPlanDetail: {},
        subStarted: false
      });
    case USER.cancelSubscription.start:
      return {
        ...state,
        isLoading: true
      };
    case USER.cancelSubscription.success:
      return {
        ...state,
        isLoading: false,
        isPlanCancelled: true
      };
    case USER.getUserTokenDetails.success:
      return Object.assign({}, state, { tokenDetails: action.data });
    case USER.getUserTokenDetails.error:
      return Object.assign({}, state, { tokenDetails: action.data });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/subscription/reducer.js